import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const nameMap: Record<string, string> = {
  '': '首页',
  'categories': '商品分类',
  'articles': '黄油知识',
  'about': '关于我们',
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const autoItems: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (items.length === 0) {
    const pathParts = location.pathname.split('/').filter(Boolean);
    pathParts.forEach((part, index) => {
      const href = '/' + pathParts.slice(0, index + 1).join('/');
      autoItems.push({
        label: nameMap[part] || part,
        href: index < pathParts.length - 1 ? href : undefined,
      });
    });
  }

  const finalItems = items.length > 0 ? items : autoItems;

  return (
    <nav aria-label="面包屑导航" className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {finalItems.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: finalItems.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.label,
              item: item.href ? `https://wlsmfl.cn${item.href}` : undefined,
            })),
          }),
        }}
      />
    </nav>
  );
}